import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

interface AdminProtectProps {
  children: React.ReactNode;
}

const AdminProtect: React.FC<AdminProtectProps> = ({ children }) => {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

  useEffect(() => {
    const verify = async () => {
      try {
        await axios.get('https://api.tbh.social/admin/verify', {
          withCredentials: true  // ✅ sends the httpOnly cookie automatically
        });
        setIsAuthenticated(true);
      } catch {
        setIsAuthenticated(false);
        navigate('/login');
      }
    };
    verify();
  }, [navigate]);

  if (isAuthenticated === null) return (
  <div style={{ height: '80vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
    <div className="w-10 h-10 border-2 border-gray-300 rounded-full animate-spin"
      style={{ borderTop: '2px solid #EC2178' }} />
  </div>
);
  return <>{isAuthenticated && children}</>;
};

export default AdminProtect;